<template>
  <button class="share-copy__text share-copy__email unstyled-btn" @click="generateEmail(shareCopy.emailSubject, shareCopy.emailBody)">
    <img class="share-copy__email-icon" alt="An icon of a box with up arrow." />{{ shareCopy.shareLinkText }}
  </button>
</template>

<script setup lang="ts">
import { useContentStore } from '../../foundation/stores/contentStore';
import { storeToRefs } from 'pinia';
import { useAnalytics } from '../../composables/useAnalytics';
import { AnalyticsEventNames, AnalyticsEvents, AnalyticsEventTypes } from '../../foundation/enums/AnalyticsEvents';
const contentStore = useContentStore();
const analytics = useAnalytics();
// Retrieve component content from content store
const { shareCopy } = storeToRefs(contentStore);

function pushToAnalytics(url: string) {
  try {
    analytics.push(AnalyticsEvents.NavigationClickToCopy, {
      eventInfo: {
        navigation: {
          name: AnalyticsEventNames.ShareToEmail,
          type: AnalyticsEventTypes.Share,
          URL: url,
        },
      },
    });
  } catch (error) {
    console.warn('fail to push data to analytics', error);
  }
}

function generateEmail(emailSubject: string, emailBody: string) {
  const url = window.location.href;
  const crlf = '%0A';
  pushToAnalytics(url);
  window.location.href = `mailto:?body=${emailBody.replaceAll('$(crlf)', crlf)} ${encodeURIComponent(url)}&subject=${emailSubject}`; // Note: %0A will insert URLEncoded line break
}
</script>

<style lang="scss" scoped>
.share-copy__email {
  display: flex;
  align-items: center;

  .share-copy__email-icon {
    width: 0.875rem;
    margin-right: 8px;
    content: url(@/assets/img/share-to-email.svg);
  }

  &:hover {
    .share-copy__email-icon {
      content: url(@/assets/img/share-to-email-blue.svg);
    }
  }
}
</style>
